// extracted by mini-css-extract-plugin
export default {"container":"container--AECTP","fixedHeight":"fixedHeight--3NEEn","body":"body--+xdpf","bodyWithIframe":"bodyWithIframe--gBZSs","iframe":"iframe--WgeIR"};